<template>
  <div>
    <div class="row align-items-center banner position-relative">
      <!--
        <div class="col-12 text-center position-absolute evento"><h1>Evento terminado</h1></div>
      -->
      <div class="col-12 text-center p-0 video-container">
        <!--
        <iframe class="iframe-replay iframe" width="640" height="350" src="https://www.youtube.com/embed/7Q-hFHOEYYA?autoplay=1&mute=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        -->
        <img :src="urlImgMO" class="img-fluid d-block d-sm-none animated fadeIn w-100 centered" @click="displayModal()"/>
        <img :src="urlImgPC" class="img-fluid d-none d-sm-block animated fadeIn w-100 centered" @click="displayModal()"/>  
      </div>
    </div>
    <!-- Comentarios falta titulo
      <div class="row mt-3">
          <div class="col-2"><img src="/img/post/corazones-izquierda.png" alt="Comentarios LiveShop EpicDay"></div>
          <div class="col-8"><img src="/img/post/comentarios-Liveshop-EpicDay.png" alt="Comentarios LiveShop EpicDay"></div>
          <div class="col-2"><img src="/img/post/corazones-derecha.png" alt="Comentarios LiveShop EpicDay"></div>
      </div>-->
<!--    <OfferCards />-->
<!--    <Tips />-->
<!--    <Programas />-->
    <div class="modal-video" v-if="showmodal">
      <div class="modal-content">
        <div class="btncerrar" role="button" @click="closeModal">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"/></svg>
        </div>
        <iframe :src="`https://www.youtube-nocookie.com/embed/${urlReplay}`" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import Tips from "@/components/Tips";
import Programas from "@/components/Programas";
import OfferCards from "@/components/OfferCards";
import VueSlickCarousel from "vue-slick-carousel";

export default {
    name: "PostLiveShop",
    props: ['urlImgPC', 'urlImgMO', 'urlReplayYT'],
    components: { Tips, Programas, OfferCards, VueSlickCarousel },
    data() {
      return{
        showmodal: false,
        modalid: '',
        urlImgPrePC: '',
        urlImgPreMO: '',
        urlReplay: ''
      }
    },
    methods:{
      displayModal(id){
        this.modalid = id
        if(this.urlReplay != ""){
          this.showmodal = true
        }
      },
      closeModal(){
        this.showmodal = false
        this.modalid = ''
      }
    },
  }
</script>
<style lang="scss" scoped>
 /*
.video-container > img{
 cursor: pointer;
}
*/
.botones{
  position: absolute;
  top: 70%;
  width: 100%;
}
.modal-video{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,.6);
  display: flex;
  z-index: 9;
.btncerrar{
  display: block;
  width: 24px;
  height: 24px;
  background: white;
  border-radius: 50%;
  padding: 0;
  position: absolute;
  right: -10px;
  top: -10px;
}
.modal-content{
  background: transparent;
  margin: auto;
  aspect-ratio: 16/9;
  position: relative;
  width: 70%;
@media only screen and (max-width: 480px) {
      margin: 20% auto;
      width: 92%;
    }
    iframe{
      width: 100%;
      aspect-ratio: 16/9;
    }
  }
}
.iframe-replay {
  min-height: 600px;
  display: block;
  margin: 0 auto;
  @media only screen and (max-width: 480px){
    min-height: 650px;
    margin: 0 auto;
  }
  & iframe{
    width: 100%;
  }
}
.evento {
  z-index: 99;
  color: #005580;
  background-color: rgb(134 134 134 / 49%);
  padding: 15px 0px 8px 0px;
  pointer-events: none;
  h1 {
    color: white !important;
  }
}

</style>